//Used in search results
export enum LocationResultType {
    PLACE,
    SWIMSPOT,
    UNKNOWN,
    WHAT3WORDS,
    BUSINESS,
    USER,
    GROUP
}